import axios from 'axios';
import { handleError, handleResponse } from '../utils/ServideHelper';

export const runCarga = (file) => {
    return new Promise((resolve, reject) => {
        const config = {
            url: '/comunicaerp/carga/sapFile',
            method: 'post',
            data: file,
        };

        axios(config).then(handleResponse(resolve)).catch(handleError(reject));
    });
};

export const getCarga = () => {
    return new Promise((resolve, reject) => {
        const config = {
            url: '/dadomestre/processing/carga',
            method: 'get',
        };

        axios(config).then(handleResponse(resolve)).catch(handleError(reject));
    });
};
